import { UserManagement } from '@/components/admin/UserManagement';
import { AdminBreadcrumb } from '@/components/AdminBreadcrumb';
import { AdminDataRefresh } from '@/components/admin/AdminDataRefresh';
import { useSEO } from '@/hooks/useSEO';

export default function AdminUsersPage() {
  useSEO({
    title: 'User Management - Admin Tools',
    description: 'Manage users, view statistics, and handle user accounts in the chess application.',
    canonical: '/admin/users',
    robots: 'noindex, nofollow'
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-purple-950/95 to-slate-950">
      <AdminBreadcrumb 
        title="User Management" 
        description="Manage user accounts, view statistics, and handle administrative tasks for chess application users."
      />
      
      <div className="max-w-7xl mx-auto p-8">
        <AdminDataRefresh />
        <UserManagement />
      </div>
    </div>
  );
}